import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, RefreshCw, BellRing } from "lucide-react";
import { toast } from "sonner";
import { api, loadAuthToken } from "../lib/api";
import { Button } from "../components/ui/button";
import { FollowupCard, groupFollowups } from "../components/followups";

const Section = ({ title, items, tone, testid, onChange }) => (
  <section data-testid={testid} className="mt-6">
    <h2 className={`text-sm uppercase tracking-widest font-semibold mb-3 ${tone}`}>{title} <span className="text-slate-400">({items.length})</span></h2>
    {items.length === 0 ? <div className="text-sm text-slate-400 rounded-lg border border-dashed border-slate-200 p-4">Kuch nahi</div> :
      <div className="space-y-3">{items.map((f) => <FollowupCard key={f.id} f={f} onChange={onChange} />)}</div>}
  </section>
);

export default function FollowupsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [, tick] = useState(0);

  const load = async () => {
    try { const r = await api.get("/followups", { params: { pending: true } }); setItems(r.data || []); }
    catch (e) {
      if (e?.response?.status === 401) navigate("/admin/login"); else toast.error("Load failed");
    }
  };

  useEffect(() => {
    if (!loadAuthToken()) { navigate("/admin/login"); return; }
    load();
    const iv = setInterval(() => { load(); tick((x) => x + 1); }, 30000);
    return () => clearInterval(iv);
    // eslint-disable-next-line
  }, []);

  const g = groupFollowups(items);
  const notifOff = typeof Notification !== "undefined" && Notification.permission !== "granted";

  return (
    <div data-testid="followups-page" className="max-w-4xl mx-auto px-4 lg:px-8 py-8">
      <div className="flex items-center justify-between mb-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-testid="followups-back"><ArrowLeft className="w-4 h-4 mr-1" /> Back</Button>
        <Button variant="outline" size="sm" onClick={load} data-testid="followups-refresh"><RefreshCw className="w-4 h-4" /></Button>
      </div>
      <h1 className="text-2xl sm:text-3xl font-heading font-semibold text-slate-900">Follow-ups &amp; Delays</h1>
      <p className="text-sm text-slate-500 mt-1">Overdue kaam red blink karenge. Kaam hone par "Done" dabayein.</p>
      {notifOff && (
        <div className="mt-4 rounded-md bg-amber-50 border border-amber-200 p-3 text-sm flex items-center justify-between gap-3 flex-wrap">
          <span className="flex items-center gap-2"><BellRing className="w-4 h-4 text-amber-700" /> Browser notification band hai — on karein taaki due time par alert aaye.</span>
          <Button size="sm" variant="outline" onClick={() => Notification.requestPermission().then(() => tick((x) => x + 1))} data-testid="enable-notif-btn">Enable</Button>
        </div>
      )}
      <Section title="Overdue" items={g.overdue} tone="text-red-700" testid="fu-section-overdue" onChange={load} />
      <Section title="Aaj (Today)" items={g.today} tone="text-amber-700" testid="fu-section-today" onChange={load} />
      <Section title="Upcoming" items={g.upcoming} tone="text-teal-700" testid="fu-section-upcoming" onChange={load} />
    </div>
  );
}
